<template>
    <div id="PageNotFoundDiv">
      <HeaderVue />
      <div class="green-bg">
          <div class="section dashboard-online">
              <div class="container">
                  <div class="row">
                      <div class="col-sm-5">
                          <h2 class="section-title red-color">404: THE PAGE YOU REQUESTED DOES NOT EXIST</h2>
                          <p class="theme-lineheight">
                            Oops. Something obviously isn’t right if you’re reading this. The URL you entered or followed no longer seems to exist, has been removed, or has been replaced. If you feel that this an error that needs to be addressed, feel free to contact the administrator of this website.
                          </p>
                      </div>
                      <div class="col-sm-7">
                          <img src="static/images/404.png" class="img-fluid section-img responsive-img" alt="">
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'

export default {
  name: 'PageNotFound',
  components: {
    HeaderVue,
    FooterVue
  },
  data () {
    return {}
  },
  beforeCreate () { },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/404.vue